import { appendStyle } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { html } from 'lit';
import { NotificationAnimationMapBaseController } from '../notifications-base-container';
export class NotificationAnimationMapController extends NotificationAnimationMapBaseController {
    constructor(element) {
        super(element);
        this.topOffset = 200;
    }
    onTemplateBuilder([id, record]) {
        return html `
      <inch-notification-view
        timestamp="${record.timestamp}"
        .config="${record.config}"
        @closeNotification="${() => this.element.closeNotification(id)}"
      >
        ${this.element.makeNotificationTemplate(record)}
      </inch-notification-view>
    `;
    }
    async onBeforeRemoveAnimateItem(element) {
        await element.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(50px) scale(0.7)', opacity: 0 }], this.animationOptions).finished;
    }
    async onBeforeRenderAnimateItem(element) {
        appendStyle(element, {
            transform: 'translateX(-110%)',
        });
    }
    async onAfterMoveAnimationItem(element, newIndex) {
        if (this.element.scrollTop >= this.topOffset) {
            return;
        }
        const rect = element.getBoundingClientRect();
        if (rect.top > window.innerHeight + this.topOffset) {
            return;
        }
        const offset = this.getOffsetByIndex(newIndex);
        await element.animate([{ transform: `translateY(${offset * -1}px)` }, { transform: `translateY(0)` }], this.animationOptions).finished;
    }
    async onAfterRenderAnimateItemTransition(element, index) {
        const offset = 100 + index * 10;
        await element.animate([
            { transform: `translateY(${offset * -1}%)`, zIndex: `-${index}` },
            { transform: 'translateY(0)', zIndex: `-${index}` },
        ], { ...this.animationOptions, duration: this.animationOptions.duration, delay: index * 200 }).finished;
    }
    onAfterRenderAnimateItemSkipTransition(element) {
        appendStyle(element, {
            transform: '',
        });
    }
}
//# sourceMappingURL=notification-animation-map-controller.js.map